<div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-btm': claim.isMox()}">
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
    <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p [ngClass]="{'mox-ui-margin-bottom-0': claim.isMox()}">{{ 'claimSection.lostPersonalItem.lossItem.description' | translate}}</p>
  </div>
  <BR>
  <div class="row col-12">
    <div class="col-xl-9 col-lg-12" [ngClass]="{'mox-ui-full-width mox-style-mg-bottom-140': claim.isMox()}">
      <form [formGroup]="lossDetailForm">
        <div formArrayName="items" *ngFor="let item of lossDetailForm.get('items')['controls']; let i = index;">
          <div [formGroupName]="i">        
            <div class="form-group click-more-content" [ngClass]="{'mox-ui-position-relative mox-ui-mg-top-8': claim.isMox()}">
              <div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-btm mox-ui-page-container-rm-pd-top mox-ui-position-relative mox-ui-width-100per': claim.isMox()}">
              <label [ngClass]="{'mox-ui-section-mg-btm': claim.isMox()}">{{ 'claimSection.lostPersonalItem.lossItem.item' | translate}} &nbsp; {{i+1}}</label><button [hidden]="i==0" class="removeBtn" (click)="removeItem(i)" [ngClass]="{'mox-ui-btn mox-ui-mg-bottom-10 mox-ui-btn-remove-absolute-right mox-ui-btn-items mox-ui-remove-item': claim.isMox()}">{{ 'claimSection.generalLabels.generalButtonLabels.remove' | translate}}</button><BR>
                <qnect-ui [fieldId]="'LOST_PERS_ITEM_11'"
                [frmArrayGroup]="lossDetailForm"
                [frmArrayName]="'items'"
                frmArrayIndex="{{i}}"
                name="lossType"></qnect-ui>
              </div>
            </div>
            <div *ngIf="detailsOfLostItemsArray && detailsOfLostItemsArray != null">
              <div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-btm mox-ui-page-container-rm-pd-top mox-ui-width-100per': claim.isMox()}">
              <div *ngIf="detailsOfLostItemsArray[i].getLossType() == 'Mobile Phone'
              || detailsOfLostItemsArray[i].getLossType() == 'Tablet'
              || detailsOfLostItemsArray[i].getLossType() == 'Laptop / Notebook'
              || detailsOfLostItemsArray[i].getLossType() == 'Sports equipment'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Luggage / Trunk'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Suitcase / Case'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Backpack / Bag'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Handbag / Briefcase'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Camera'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Wallet'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Earphones / Headphones'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Watch'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Others'
              || this.detailsOfLostItemsArray[i].getLossType() == 'Chargers / Memory cards'">
                <div *ngIf="this.detailsOfLostItemsArray[i].getLossType() == 'Mobile Phone'" class="form-group">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_24'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="lossTypeDetail"></qnect-ui>
                </div>
                <div *ngIf="this.detailsOfLostItemsArray[i].getLossType() == 'Others'" class="form-group">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_20'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="otherTypeBriefDesc"></qnect-ui>
                </div>
                <div class="form-group">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_12'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            [aboveMaxDateValidator]="this.claim.getClaimTravel().getLostPersonalItem().getDateTheDamageOccurred()"
                            name="purchaseDate"></qnect-ui>
                </div>
                <div class="form-group click-more-content">
                    <qnect-ui [fieldId]="'LOST_PERS_ITEM_13'"
                              [frmArrayGroup]="lossDetailForm"
                              [frmArrayName]="'items'"
                              frmArrayIndex="{{i}}"
                              name="purchasePrice"></qnect-ui>
                </div>
                <div *ngIf="this.detailsOfLostItemsArray[i].getLossType() == 'Watch' && this.claim.getCountry().toLowerCase() != 'hgi'" class="form-group click-more-content">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_23'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="wasWatchBeingStored"></qnect-ui>
                </div>
                <div class="form-group" *ngIf="this.claim.getCountry().toLowerCase() == 'hkg' || this.claim.getCountry().toLowerCase() == 'hgi'">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_25'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="hasOriginalPurchasedReceipt"></qnect-ui>
                  <div class="row col-md-8 col-xs-12" *ngIf="this.detailsOfLostItemsArray[i].getHasOriginalPurchasedReceipt() == true">
                    <span style="margin-right: auto">
                      <small>{{'claimSection.damagePersonalItem.detailsOfDamageItems.hasOriginalPurchasedReceiptDesc1' | translate}}</small>
                    </span>
                  </div>
                  <div class="row col-md-8 col-xs-12" *ngIf="this.detailsOfLostItemsArray[i].getHasOriginalPurchasedReceipt() == false">
                    <span style="margin-right: auto">
                      <small>{{'claimSection.damagePersonalItem.detailsOfDamageItems.hasOriginalPurchasedReceiptDesc2' | translate}}</small>
                    </span>
                    <span style="margin-right: auto">
                      <small>{{'claimSection.damagePersonalItem.detailsOfDamageItems.hasOriginalPurchasedReceiptDesc3' | translate}}</small>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="['Passport / HKID / China Re-entry card', 'Passport / NRIC / FIN', 'Passport / NRIC'].indexOf(detailsOfLostItemsArray[i].getLossType())!==-1">
                <div class="form-group click-more-content">
                    <qnect-ui [fieldId]="'LOST_PERS_ITEM_14'"
                              [frmArrayGroup]="lossDetailForm"
                              [frmArrayName]="'items'"
                              frmArrayIndex="{{i}}"
                              name="costOfRepalceCost"></qnect-ui>
                </div>
                <div class="form-group">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_21'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="hasExtraTransCost"></qnect-ui>
                  <div *ngIf="detailsOfLostItemsArray[i].getHasExtraTransCost()">
                      <qnect-ui [fieldId]="'LOST_PERS_ITEM_15'"
                                  [frmArrayGroup]="lossDetailForm"
                                  [frmArrayName]="'items'"
                                  frmArrayIndex="{{i}}"
                                  name="costOfTransCost"></qnect-ui>
                  </div>
                </div>
                <div class="form-group">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_22'"
                            [frmArrayGroup]="lossDetailForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="hasExtraAccomCost"></qnect-ui>
                  <div *ngIf="detailsOfLostItemsArray[i].getHasExtraAccomCost()">
                    <qnect-ui [fieldId]="'LOST_PERS_ITEM_16'"
                                [frmArrayGroup]="lossDetailForm"
                                [frmArrayName]="'items'"
                                frmArrayIndex="{{i}}"
                                name="costOfAccomCost"></qnect-ui>
                  </div>
                </div>
              </div>
              <div *ngIf="detailsOfLostItemsArray[i].getLossType() == 'Personal Money'">
                <div class="form-group click-more-content">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_17'"
                              [frmArrayGroup]="lossDetailForm"
                              [frmArrayName]="'items'"
                              frmArrayIndex="{{i}}"
                              name="lostMoneyAmount"></qnect-ui>
                </div>
              </div>
              <div *ngIf="detailsOfLostItemsArray[i].getLossType() == 'Credit Card'">
                <div class="form-group click-more-content">
                  <qnect-ui [fieldId]="'LOST_PERS_ITEM_18'"
                              [frmArrayGroup]="lossDetailForm"
                              [frmArrayName]="'items'"
                              frmArrayIndex="{{i}}"
                              name="unauthorisedMoneyLoss"></qnect-ui>
                </div>
              </div>
              </div>
              <!-- bubble depreciation info -->
              <div *ngIf="detailsOfLostItemsArray[i].getLossType() != null && detailsOfLostItemsArray[i].getLossType() != ''" [ngClass]="{'mox-ui-full-width mox-ui-section-mg-btm': claim.isMox()}">
                <div class="dept-del-info col-xl-8 col-xs-12 col-md-8" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
                  <div class="row col-12 col-md-12" [ngClass]="{'mox-ui-page-container mox-ui-page-container-pd-30 mox-ui-align-items-center': claim.isMox()}">
                    <div class="col-3 col-md-2 percent-text hide"> % </div>
                    <div class="col-3 col-md-2 percent-text" *ngIf="claim.isMox()">
                      <img src="assets/images/ic_important_information.svg" alt="plus"  class="plus-img"/>
                    </div>  
                    <div class=" col-9 col-md-10 dept-desc-text" [ngClass]="{'mox-ui-font-size-14': claim.isMox()}">{{'claimSection.damagePersonalItem.detailsOfDamageItems.depreciationInfo' | translate}}</div>
                  </div>
                </div>
              </div>
              <!-- bubble depreciation info -->
            </div>
            <div class="col-xl-2 col-lg-12 hide">
                &nbsp;
            </div>
          </div>
        </div>
      </form>
      <div [ngClass]="{'mox-ui-page-container mox-ui-page-container-rm-pd-top mox-ui-page-container-rm-pd-btm': claim.isMox()}">
      <div class="addFile" (click)="addItem()" [ngClass]="{'mox-ui-font-size-14 mox-ui-mg-top-8 mox-ui-add-file': claim.isMox()}">
        <i class="fas fa-plus" *ngIf="!claim.isMox()"></i>
        <img src="assets/images/Add.svg" alt="plus" class="plus-img" *ngIf="claim.isMox()"/>
        <span>{{ 'claimSection.generalLabels.generalButtonLabels.add' | translate}}</span>
      </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-12">
      &nbsp;
    </div>
  </div>

  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" [hidden]="claim.isMox()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn new-btn btn-primary float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right" ></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
